import { render, staticRenderFns } from "./PostLead.vue?vue&type=template&id=bc3bad06&"
import script from "./PostLead.vue?vue&type=script&lang=js&"
export * from "./PostLead.vue?vue&type=script&lang=js&"
import style0 from "./PostLead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports